import { callApi, callApiV2 } from 'utils';
import { getI18nLng } from 'utils/i18n';

/**
 * @param {string} videoId
 * @param {number} pageNumber
 * @return {Promise<T>}
 */
export function fetchRelatedVideosApi(videoId, pageNumber) {
  const language = getI18nLng();
  return callApi(`videos/${videoId}/related?pageNum=${pageNumber}&perPage=7&lang=${language}`);
}

/**
 * @param {string} videoId
 * @param {number} pageCursor
 * @return {Promise<T>}
 */
export function fetchRelatedVideosIqsApi(videoId, pageCursor) {
  const language = getI18nLng();
  return callApiV2(`videos/${videoId}/related?pageCursor=${pageCursor}&pageSize=7&lang=${language}`);
}
